import React from 'react'
import { ReactSVG } from 'react-svg'
import { Link } from 'react-router-dom'
import UserShortInfo from './UserShortInfo'
import Navigation from './Navigation'
import Btn from './Btn'

function Sidebar(): React.JSX.Element {
  const sidebarRef = React.useRef<HTMLDivElement>(null)
  const menuRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    const resizeHandler = (): void => {
      const html = document.documentElement
      html.style.setProperty(
        '--sidebar-width',
        `${sidebarRef.current?.offsetWidth ?? 0}px`
      )

      const menu = menuRef.current
      if (!menu) return

      const menuRect = menu.getBoundingClientRect()
      const height = window.innerHeight - menuRect.top
      menu.style.setProperty('height', `${height}px`)
    }

    window.addEventListener('resize', resizeHandler)
    resizeHandler()

    return (): void => {
      window.removeEventListener('resize', resizeHandler)
    }
  })

  return (
    <div ref={sidebarRef} className={'sidebar'}>
      <div className={'sidebar__logo'}>
        <Link to={'/'} aria-label={'homepage'}>
          <ReactSVG src={'/i/logo-sm.svg'} wrapper={'span'}></ReactSVG>
        </Link>
      </div>
      <div className={'sidebar__user'}>
        <UserShortInfo hasLink></UserShortInfo>
      </div>
      <div ref={menuRef} className={'sidebar__menu'}>
        <Navigation></Navigation>
        <Btn
          target={'_blank'}
          rel={'noopener noreferrer'}
          href={'https://goup.guap.ru/'}
          text
          className={'mt-lg-8 mt-md-8 mt-sm-6 ml-lg-3 ml-md-3 ml-sm-2'}
        >
          <span>Сайт Орбита</span>
          <ReactSVG src={`/i/svg/arrow-right.svg`} wrapper={'span'} />
        </Btn>
      </div>
    </div>
  )
}

export default Sidebar
